var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import queryString from 'query-string';
import { toTitleCase } from '@ally/aos-utils';
import { MboxTemplate, StyledMbox } from './StyledMbox';
export var LoginNotificationMBoxes = function (_a) {
    var rawQueryParams = _a.rawQueryParams, isInPortal = _a.isInPortal;
    var capitalizeSentence = function (stringArray) {
        return stringArray
            .map(function (element) {
            if (element.includes(' ')) {
                return element
                    .split(' ')
                    .map(function (el) { return toTitleCase(el); })
                    .join(' ');
            }
            return toTitleCase(element);
        })
            .join(' / ');
    };
    var queryParamRegex = /(bank|invest|credit card|home loans|auto)/gi;
    var getMBoxContent = function (queryParams) {
        var matches = queryParams.match(queryParamRegex) || [''];
        return capitalizeSentence(matches);
    };
    // NOTE: queryString.parse(rawQueryParams) interpolates `%20` as whitespace | ' '
    var params = queryString.parse(rawQueryParams);
    var isLinkedFromBankInvestCC = params.linkRelationships
        ? queryParamRegex.test(__spreadArray([], __read(params.linkRelationships), false).join(''))
        : false;
    var mboxName = 'ally-login-notifications';
    var content = isLinkedFromBankInvestCC && params.linkRelationships
        ? {
            __html: "Log in with your <b>".concat(getMBoxContent(params.linkRelationships), "</b> username to finish linking."),
        }
        : { __html: '' };
    return (React.createElement(React.Fragment, null,
        !isInPortal && !isLinkedFromBankInvestCC && (React.createElement(StyledMbox, { name: mboxName })),
        isLinkedFromBankInvestCC && (React.createElement(MboxTemplate, { content: content, template: "icon-notification" }))));
};
//# sourceMappingURL=LoginNotificationMBoxes.js.map